<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "RouterContainer",
  methods: {}
};
</script>
